import store from "../../store/store";
import locals from "../localStorage";
import Firm from "../../entities/firm";
import {uuid} from "../../@types/schema";
import User from "../../entities/user";
import type Contact from "../../entities/contact";
import {getContactFromUser} from "./getContactFromUser";
import {getSessionFirmId, getSessionUserId} from "./sessionIdentity";

/**
 * Is the currently logged-in user a portal user?
 *
 * @returns {boolean}
 */
export function isPortalUser(): boolean {
	return !!store.getState().misc.portalUser;
}

/**
 * @returns {uuid}
 */
export function getCurrentUserId(): uuid {
	return getSessionUserId() || null;
}

/**
 * @returns {uuid}
 */
export function getCurrentFirmId(): uuid {
	return getSessionFirmId() || null;
}

/**
 * @returns {User}
 */
export function getCurrentUser(): User {
	return store.getState().users.get(getCurrentUserId()) ?? null;
}

/**
 * The signed-in user's contact record (their name). Users arrive without an
 * embedded contact, so it is looked up by contactId; null until it is loaded.
 *
 * @returns {Contact}
 */
export function getCurrentUserContact(): Contact {
	return getContactFromUser(getCurrentUser()) ?? null;
}

/**
 * @returns {Firm}
 */
export function getCurrentFirm(): Firm {
	let firm = store.getState().firms.get(getSessionFirmId());

	if (!!firm) return firm;
	else {
		const firmId = getSessionFirmId();
		const userId = getSessionUserId();
		if (!firmId || !userId) return null;
		const firm = locals.getObject(`${locals.USER_FIRM}-${firmId}-${userId}`, null) as Firm | null;
		// The cache holds the plain JSON the login bootstrap stored: `firmId`, never the `id` getter (OWA-844).
		if (firm?.firmId === firmId) return new Firm(firm);
		else return null;
	}
}

export function getSystemUUID(): uuid {
	return '647acced-da76-49a3-aa83-965782e80b49';
}
